import { Set } from "immutable";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { getCampaign as getParentCampaign } from "data/parent-campaign";

import {
  getAvailableVotes,
  getDonationId,
  getError,
  getLoading,
  getSelectedCampaigns,
  getTotalVotes,
  getVotingUserId,
  resetSelectedVotes,
  selectCampaign,
  setInitialVotes,
  setVotes,
  submitVotes,
} from "data/voting-form/voting";

import { nextPage, previousPage } from "data/voting-form/routes";

import SearchInCategory from "./SearchInCategory";

export class Vote extends React.Component {
  static propTypes = {
    campaignId: PropTypes.string.isRequired,
    userId: PropTypes.string.isRequired,
    submitVoteError: PropTypes.string,
    availableVotes: PropTypes.number.isRequired,
    totalVotes: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired,
    selectedCampaigns: PropTypes.instanceOf(Set).isRequired,

    setVotes: PropTypes.func.isRequired,
    setInitialVotes: PropTypes.func.isRequired,
    nextPage: PropTypes.func.isRequired,
    previousPage: PropTypes.func.isRequired,
    submitVotes: PropTypes.func.isRequired,
    selectCampaign: PropTypes.func.isRequired,
    resetSelectedVotes: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { selectCampaign, parentCampaign } = this.props;
    selectCampaign(parentCampaign, true);
  }

  handleCloseModal = () => {
    const { onCloseModal } = this.props;
    onCloseModal();
  };

  handleRemoveCampaign = (campaign) => {
    this.handleCampaignSelect(campaign, false);
  };

  handleSetVotes = (campaign, votes) => {
    const { setVotes } = this.props;
    setVotes(campaign, votes);
  };

  handleCampaignSelect = (campaign, bool) => {
    const { selectCampaign } = this.props;
    selectCampaign(campaign, bool);
  };

  handleVoteSubmission = () => {
    const { donationId, userId, selectedCampaigns, parentCampaign, availableVotes } =
      this.props;
    const { setInitialVotes, submitVotes, nextPage } = this.props;

    submitVotes({
      donationId,
      userId,
      parentCampaignId: parentCampaign.get("id"),
      campaigns: selectedCampaigns,
    }).then(() => {
      setInitialVotes(availableVotes);
      nextPage();
    });
  };

  handleVoteStepBack = () => {
    const { resetSelectedVotes, previousPage, totalVotes } = this.props;

    resetSelectedVotes(totalVotes);
    previousPage();
  };

  renderVoteButton() {
    const { isLoading, selectedCampaigns, totalVotes, availableVotes } = this.props;

    const text =
      isLoading === true ? <i className="fa fa-refresh fa-spin" /> : "vote now";

    const disabled =
      selectedCampaigns.count() <= 0 ||
      totalVotes === availableVotes ||
      totalVotes === 0 ||
      availableVotes > 0;

    return (
      <button
        data-testid="t-Vote-button"
        className="voting-modal-btn secondary-color-background"
        onClick={this.handleVoteSubmission}
        disabled={disabled}>
        {text}
      </button>
    );
  }

  render() {
    const { availableVotes, submitVoteError } = this.props;

    return (
      <section className="voting-modal primary-color-background">
        <div className="voting-modal-background">
          <button
            data-testid="t-Vote-modal-close-button"
            aria-label="Modal Close Button"
            className="modal-close-button secondary-color-text"
            onClick={this.handleCloseModal}>
            <i className="fa fa-times fa-2x" />
          </button>
          <div className="voting-modal-top">
            <div className="voting-modal-header-area">
              <h2 className="voting-modal-header">
                Give &gt; <span className="step-active secondary-color-text">Vote</span>{" "}
                &gt; Watch
              </h2>
              <span className="white-font-color">
                Allocate your {availableVotes || 0}{" "}
                {availableVotes >= 2 ? `votes` : `vote`}.
              </span>
            </div>
          </div>
          <div className="voting-modal-body">
            <div className="voting-modal-body-inside">
              <SearchInCategory
                noAvailableVotes={availableVotes <= 0}
                setVotes={this.handleSetVotes}
                removeCampaign={this.handleRemoveCampaign}
              />
            </div>
          </div>
          <div>
            <button
              data-testid="t-Vote-button-3"
              className="voting-modal-btn--left secondary-color-background"
              onClick={this.handleVoteStepBack}>
              Back
            </button>
            {this.renderVoteButton()}
            {submitVoteError ? (
              <div>
                <span className="text-danger">{submitVoteError}</span>
              </div>
            ) : null}
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    availableVotes: getAvailableVotes(state),
    donationId: getDonationId(state),
    totalVotes: getTotalVotes(state),
    isLoading: getLoading(state),
    selectedCampaigns: getSelectedCampaigns(state),
    userId: getVotingUserId(state),
    parentCampaign: getParentCampaign(state)("voting_form"),
    submitVoteError: getError(state),
  };
};

const mapActionCreators = {
  nextPage,
  previousPage,
  selectCampaign,
  setInitialVotes,
  setVotes,
  submitVotes,
  resetSelectedVotes,
};
export default connect(mapStateToProps, mapActionCreators)(Vote);
